/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editsaving1Inputs */

const en_editsaving1 = /** @type {(inputs: Editsaving1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving…`)
};

const de_editsaving1 = /** @type {(inputs: Editsaving1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gespeichert…`)
};

/**
* | output |
* | --- |
* | "Saving…" |
*
* @param {Editsaving1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const editsaving1 = /** @type {((inputs?: Editsaving1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editsaving1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_editsaving1(inputs)
	return de_editsaving1(inputs)
});
export { editsaving1 as "editSaving" }